import React from "react";

export const Loading: React.FC = () => (
    <div
        style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#FAFBFD",
            fontFamily: "system-ui, sans-serif",
            color: "#1F2937",
            gap: 16,
        }}
    >
        <div
            style={{
                width: 36,
                height: 36,
                border: "3px solid #E5E7EB",
                borderTopColor: "#2F6FED",
                borderRadius: "50%",
                animation: "metrics-auth-spin 0.9s linear infinite",
            }}
        />
        <div style={{ fontSize: 14, color: "#6B7280" }}>Loading…</div>
        <style>{"@keyframes metrics-auth-spin { to { transform: rotate(360deg); } }"}</style>
    </div>
);
